import { LocationStrategy } from '@angular/common'
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { ERROR, InfoError } from '../classes/errors.model'
import { ClientService } from '../services/client.service'
import { SpinnerService } from '../services/spinner.service'
import { StepperService } from '../services/stepper.service'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  contador
  constructor(
    private spinnerService: SpinnerService,
    private stepperService: StepperService,
    private clientService: ClientService,
    private locationStrategy: LocationStrategy
  ) {}
  preventBackButton() {
    history.pushState(null, null, location.href)
    this.locationStrategy.onPopState(() => {
      history.pushState(null, null, location.href)
    })
  }
  Conteo5Seg() {
    sessionStorage.setItem('inicio_session', '0')
    this.preventBackButton()
    this.contador = setTimeout(() => {
      this.stepperService.setErrorGenerico(
        ERROR.sesion_expirada.update({ btn: 'null' })
      )
      if (this.clientService.client.id_tramite) {
        const info = this.clientService.postEventosSync(
          'Sesion Expirada',
          'eventos_aplicativo'
        )
      }
      clearTimeout(this.contador)
    }, 5000)
  }

  setError(typeError: InfoError) {
    this.stepperService.setErrorGenerico(
      typeError.update({
        btn:
          'Volver a Comenzar | ' + this.clientService.GetSStorageVuelta().link,
        estado: true,
      })
    )
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        const error = err.error || err.statusText
        if (error.message) {
          err.error['message'] = error.message
        }
        switch (err.status) {
          case 400:
            switch (err.error.message) {
              case 'E0085':
                this.setError(ERROR.validacion_form)
                break
              case 'E0086':
                this.setError(ERROR.validacion_form_document)
                break
              case 'E0087':
                this.setError(ERROR.validacion_form)
                break
              case 'E0088':
                this.setError(ERROR.validacion_form)
                break
              case 'E0089':
                this.setError(ERROR.actualizacion_datos)
                break
              case 'E0090':
                this.setError(ERROR.actualizacion_datos)
                break
              case 'E0091':
                this.setError(ERROR.actualizacion_datos)
                break
              case 'E00102':
                this.setError(ERROR.disponibilidad)
                break
              case 'E00103':
                this.setError(ERROR.disponibilidad)
                break
              case 'E00104':
                this.setError(ERROR.disponibilidad)
                break
              case 'E0080':
                this.setError(ERROR.codigo_sms)
                break
              case 'E0092':
                // cedo control a componente
                break
              case 'E0093':
                this.setError(ERROR.disponibilidad)
                break
              case 'E00107':
                this.setError(ERROR.reenvios_superados)
                break
              case 'E0071':
                this.setError(ERROR.codigo_token)
                break
              case 'E0041': // token virtual
                // cedemos el control al componente
                break
              case 'E0042':
                this.setError(ERROR.disponibilidad)
                break
              case 'E0097': //generacion
                // cedemos el control al componente
                break
              case 'E0098':
                // cedemos el control al componente
                break
              case 'E0099':
                this.setError(ERROR.generacion_clave)
                break
              case 'E00100':
                this.setError(ERROR.generacion_clave)
                break
              case 'E00101':
                this.setError(ERROR.disponibilidad)
                break
              case 'E00111':
                this.setError(ERROR.blanqueo_clave_identificacion)
                break
              case 'E00112':
                this.setError(ERROR.desbloqueo_user_eBanking)
                break
              case 'E00113':
                this.setError(ERROR.blanqueo_clave_desbloqueo_user)
                break
              case 'E0094': // mail
                // cedemos el control al componente
                break
              case 'E0095':
                this.setError(ERROR.codigo_email)
                break
              case 'E0096':
                this.setError(ERROR.disponibilidad)
                break
              case 'E00108':
                this.setError(ERROR.reenvios_superados)
                break
              case 'E00109': // renaper
                this.setError(ERROR.validacion_form)
                break
              case 'E00110':
                this.setError(ERROR.disponibilidad)
                break
              default:
                this.setError(ERROR.disponibilidad)
                break
            }
            break
          case 502:
            this.setError(ERROR.disponibilidad)
            break
          case 503:
            this.setError(ERROR.disponibilidad)
            break
          default:
            this.setError(ERROR.disponibilidad)
            break
        }
        this.spinnerService.hideSpinner()
        return throwError(error)
      })
    )
  }
}
